var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.d_reportList.list.length > 0)?_c('report-module',{ref:"ref_report_module",attrs:{"p_reportData":_vm.d_reportData,"p_reportList":_vm.d_reportList,"f_selectThisreport":_vm.f_selectThisreport,"f_reportViewRecord":_vm.f_reportViewRecord,"p_reportDashboard":_vm.d_reportDashboard}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }